import React, { Component } from "react";
import {
  clearClientAttest,
  clientModalRequest,
} from "../../../../services/complianceAPIServices";
import DropDown from "../../../common/dropDown";
import ClientRequestModal from "./clientRequestModal";
import AddAccountModal from "./addAccountModal";
import ConfirmDeleteModal from "./confirmDeleteModal";
import Modal from "../../../common/Modal";

export default class ClientModal extends Component {
  constructor(props) {
    super(props);
    this.date = new Date();
    this.state = {
      disableClearCurrent: true,
      disableClearPrevious: true,
      saveFlag: false,
      elevated: false,
      notesDate: `${this.date.getFullYear()}`,
      clicked: undefined,
      currentYear: this.date.getFullYear(),
      currentMonth: this.date.getMonth(),
      defaultTextArea: !this.props.data.notes.find(
        (d) => d.year === `${this.date.getFullYear()}`
      )
        ? ""
        : this.props.data.notes[0].note,
      clientNotes: !this.props.data.notes.find(
        (d) => d.year === `${this.date.getFullYear()}`
      )
        ? !this.props.data.notes.find(
            (d) => d.year === `${this.date.getFullYear() - 1}`
          )
          ? [
              { year: `${this.date.getFullYear()}`, note: "" },
              { year: `${this.date.getFullYear() - 1}`, note: "" },
              ...this.props.data.notes,
            ]
          : [
              { year: `${this.date.getFullYear()}`, note: "" },
              ...this.props.data.notes,
            ]
        : this.props.data.notes,
      scrollPosition: 0,
      showAddAccountModal: false,
      showDeleteAccountModal: false,
      clearConfirmType: null,
      accountToDelete: null,
      accountTypeToDelete: null,
    };
  }

  handleAddAccount = (accountNumber, registrationType) => {
    // TODO: Call API to add account (F3-Backend)
    const { data: client } = this.props;
    clientModalRequest(
      client,
      `ADD ACCOUNT REQUEST:\nAccount Number: ${accountNumber}\nRegistration Type: ${registrationType}`
    );
    alert("Add account request sent to compliance!");
  };

  handleRemoveAccount = (account, accountType) => {
    // TODO: Call API to remove account (F3-Backend)
    const { data: client } = this.props;
    clientModalRequest(
      client,
      `REMOVE ACCOUNT REQUEST:\nAccount Number: ${account}\nRegistration Type: ${accountType}`
    );
    alert("Remove account request sent to compliance!");
  };

  componentDidMount = () => {
    const groups = this.props.groups;
    const groupLogic =
      groups.includes("compliance") || groups.includes("system_admin");
    if (groupLogic) {
      this.setState({ elevated: true });
    }
    this.setState({ scrollPosition: this.props.GetScrollPosition() });
    this.handleClientClearDisabled();
    this.handleClientClearDisabled(false);
  };

  handleTextAreaUpdate = (updateText) => {
    let CN = this.state.clientNotes;
    if (!this.state.saveFlag) {
      this.setState({ saveFlag: true });
    }
    let yearNote = CN.find((cn) => cn.year === this.state.notesDate);
    let indexYearNote = CN.indexOf(yearNote);
    CN[indexYearNote].note = updateText;
    this.setState({
      clientNotes: CN,
      defaultTextArea: updateText,
    });
  };

  handleClientClear = (client, current = true) => {
    clearClientAttest(client);
    this.props.handleClientUpdate(client, "attestation-status", {
      "attestation-status": "Not Submitted",
    });
    this.props.handleClientUpdate(client, "review-date", {
      "review-date": "-",
    });
    this.props.handleClientUpdate(client, "account-r-t-a-changes", {
      "account-r-t-a-changes": "-",
    });
    this.props.handleClientUpdate(client, "account-substantial-change", {
      "account-substantial-change": "-",
    });
    this.props.handleClientUpdate(client, "review-structure", {
      "review-structure": "-",
    });
    this.props.handleClientUpdate(client, "reviewed-this-year", {
      "reviewed-this-year": "-",
    });
    this.props.handleClientUpdate(client, "reg-b-i-changes", {
      "reg-b-i-changes": "-",
    });
    Object.keys(client.accounts[current ? "Current" : "Previous"]).forEach(
      (custodianKey) => {
        client.accounts[current ? "Current" : "Previous"][custodianKey].forEach(
          (account) => {
            if (String(account.submitted).toLowerCase() === "true") {
              account.submitted = "";
            }
          }
        );
      }
    );
    this.props.submitClientUpdate(client);
    this.props.onClose();
  };

  handleClientClearDisabled = (current = true) => {
    const { data: client, clients } = this.props;
    const yearKey = current ? "Current" : "Previous";
    clients.forEach((c) => {
      if (client["client-name"] === c["client-name"]) {
        Object.keys(c.accounts[yearKey]).forEach((accountType) => {
          c.accounts[yearKey][accountType].forEach((accountItem) => {
            if (
              accountItem.submitted === "true" ||
              accountItem.submitted === true
            ) {
              const currPrevState = current
                ? "disableClearCurrent"
                : "disableClearPrevious";
              this.setState({ [currPrevState]: false });
            }
          });
        });
      }
    });
  };

  handleNotesSave = async (client, clientNotes) => {
    // UI side
    this.props.handleClientUpdate(client, "notes", {
      notes: clientNotes,
    });
    // Server Side
    this.props.submitClientUpdate(client, "notes");
  };

  render() {
    const {
      data: client,
      accountName,
      onClose,
      handleClientArchive,
    } = this.props;
    const {
      elevated,
      currentYear,
      defaultTextArea,
      notesDate,
      saveFlag,
      clientNotes,
      disableClearPrevious,
      disableClearCurrent,
      clicked,
      clearConfirmType,
      showAddAccountModal,
      showDeleteAccountModal,
      accountToDelete,
      accountTypeToDelete,
    } = this.state;

    return (
      <>
        <ClientRequestModal
          show={!!clicked}
          data={client}
          onClose={() => this.setState({ clicked: undefined })}
        />
        <AddAccountModal
          show={showAddAccountModal}
          clientName={accountName}
          onConfirm={this.handleAddAccount}
          onClose={() => this.setState({ showAddAccountModal: false })}
        />
        <ConfirmDeleteModal
          show={showDeleteAccountModal && !!accountToDelete}
          account={accountToDelete}
          accountType={accountTypeToDelete}
          onConfirm={this.handleRemoveAccount}
          onClose={() =>
            this.setState({
              showDeleteAccountModal: false,
              accountToDelete: null,
              accountTypeToDelete: null,
            })
          }
        />
        <Modal
          show={!!clearConfirmType}
          onClose={() => this.setState({ clearConfirmType: null })}
        >
          <div className="modal-header bg-warning">
            <h5 className="modal-title">
              Clear {clearConfirmType === "current" ? "Current" : "Previous"}{" "}
              Attestation
            </h5>
            <button
              type="button"
              className="btn-close"
              onClick={() => this.setState({ clearConfirmType: null })}
              aria-label="Close"
            ></button>
          </div>
          <div className="modal-body">
            <p>
              Are you sure you want to clear the{" "}
              {clearConfirmType === "current" ? "current" : "previous"}{" "}
              attestation for <strong>{accountName}</strong>?
            </p>
            <div className="alert alert-warning">
              This will clear the{" "}
              {clearConfirmType === "current" ? "current" : "previous"}{" "}
              attestation account data, remove the most recent history entry,
              and reset the attestation status fields displayed in the table.
            </div>
          </div>
          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-secondary"
              onClick={() => this.setState({ clearConfirmType: null })}
            >
              Cancel
            </button>
            <button
              type="button"
              className="btn btn-warning"
              onClick={() => {
                const isCurrent = clearConfirmType === "current";
                this.setState({ clearConfirmType: null });
                this.handleClientClear(client, isCurrent);
              }}
            >
              Clear {clearConfirmType === "current" ? "Current" : "Previous"}
            </button>
          </div>
        </Modal>
        <Modal show={!!client} onClose={onClose} size="lg">
            <div className="modal-header">
              <h5 className="modal-title" id="staticBackdropLabel">
                {accountName}
              </h5>
              <button
                type="button"
                className="btn btn-primary mx-auto"
                onClick={() => {
                  this.setState({ clicked: true });
                }}
                aria-label="Close"
              >
                Request: Change or Removal
              </button>
              <button
                type="button"
                className="btn-close"
                onClick={onClose}
                aria-label="Close"
              ></button>
            </div>
            <div className="modal-body">
              {(Object.keys(client.accounts["Current"])[0] !== undefined ||
                Object.keys(client.accounts["Previous"])[0] !== undefined) &&
                Object.keys(
                  client.accounts[
                    Object.keys(client.accounts["Current"])[0] !== undefined
                      ? "Current"
                      : "Previous"
                  ]
                )[0].length > 0 && (
                  <div>
                    <h4 className="text-start mb-3">Accounts:</h4>
                    <hr />
                    {Object.keys(
                      client.accounts[
                        Object.keys(client.accounts["Current"])[0] !== undefined
                          ? "Current"
                          : "Previous"
                      ]
                    ).map((type, i) => (
                      <div key={i}>
                        <dl className="row g-0 text-start m-0 text-break">
                          <dt className="col-sm-3">Type:</dt>
                          <dd className="col-sm-9">{type}</dd>
                          <dt className="col-sm-3">
                            Identifiers:
                            {/* TODO: QOL Phase 2 - Add Account button
                            <button
                              className="btn btn-success btn-sm ms-2"
                              style={{
                                padding: "0 6px",
                                fontSize: "12px",
                                lineHeight: "1.2",
                              }}
                              onClick={() =>
                                this.setState({ showAddAccountModal: true })
                              }
                              title="Add Account"
                            >
                              +
                            </button>
                            */}
                          </dt>
                          <dd className="col-sm-9">
                            {client.accounts[
                              Object.keys(client.accounts["Current"])[0] !==
                              undefined
                                ? "Current"
                                : "Previous"
                            ][type].map((accountItem, i) => (
                              <span
                                key={i}
                                className="m-1 d-inline-flex align-items-center"
                                style={{
                                  borderRadius: "25px",
                                  border: "2px solid #92a8d1",
                                  padding: "0 2px 0 8px",
                                }}
                              >
                                {accountItem.account}
                                {/* TODO: QOL Phase 2 - Remove Account button
                                <button
                                  className="btn btn-link text-danger p-0 ms-1"
                                  style={{
                                    fontSize: "14px",
                                    lineHeight: "1",
                                    textDecoration: "none",
                                  }}
                                  onClick={() =>
                                    this.setState({
                                      showDeleteAccountModal: true,
                                      accountToDelete: accountItem.account,
                                      accountTypeToDelete: type,
                                    })
                                  }
                                  title="Remove Account"
                                >
                                  &times;
                                </button>
                                */}
                              </span>
                            ))}
                          </dd>
                        </dl>
                      </div>
                    ))}
                  </div>
                )}
              {elevated && (
                <div>
                  <h4 className="text-start mb-3 mt-3">Notes:</h4>
                  <hr />
                  <>
                    {clientNotes.length > 0 && (
                      <>
                        <div className="d-inline-block float-start mb-2">
                          <DropDown
                            title={notesDate}
                            items={clientNotes
                              .sort((a, b) => {
                                a = parseInt(a.year);
                                b = parseInt(b.year);
                                return a < b ? 1 : a > b ? -1 : 0;
                              })
                              .map((d) => (d = d.year))}
                            textProperty={"name"}
                            valueProperty={""}
                            selectedItem={0}
                            onItemSelect={(e) => {
                              this.setState({
                                notesDate: `${e}`,
                                defaultTextArea: clientNotes.find(
                                  (d) => d.year === `${e}`
                                ).note,
                              });
                            }}
                          />
                        </div>
                        <div className="float-start d-flex mb-2"></div>
                        <form className="mb-2">
                          <div className="form-group">
                            <textarea
                              className="form-control"
                              id="message-text"
                              value={defaultTextArea}
                              onChange={(e) => {
                                this.handleTextAreaUpdate(e.target.value);
                              }}
                              disabled={`${notesDate}` <= `${currentYear - 2}`}
                            ></textarea>
                          </div>
                        </form>
                      </>
                    )}
                  </>
                </div>
              )}
            </div>
            <div>
              <div className="modal-footer justify-content-between bd-highlight">
                <div className="bd-highlight">
                  {elevated && (
                    <>
                      <button
                        type="button"
                        className="btn btn-primary"
                        onClick={() => {
                          this.setState({ clearConfirmType: "current" });
                        }}
                        disabled={disableClearCurrent}
                      >
                        Clear Current Attest
                      </button>
                      <button
                        type="button"
                        className="btn btn-primary ms-2"
                        onClick={() => {
                          this.setState({ clearConfirmType: "previous" });
                        }}
                        disabled={disableClearPrevious}
                      >
                        Clear Previous Attest
                      </button>
                      <button
                        type="button"
                        className="btn btn-warning ms-2"
                        onClick={() => {
                          handleClientArchive(client);
                          onClose();
                        }}
                      >
                        Archive
                      </button>
                    </>
                  )}
                </div>

                <div className="bd-highlight">
                  <button
                    type="button"
                    className="btn btn-secondary"
                    onClick={onClose}
                  >
                    {saveFlag ? "Cancel" : "Close"}
                  </button>
                  {saveFlag && (
                    <button
                      style={{ marginLeft: "9px" }}
                      type="button"
                      className="btn btn-primary float-end"
                      onClick={() => {
                        this.handleNotesSave(client, clientNotes);
                      }}
                      disabled={`${notesDate}` <= `${currentYear - 2}`}
                    >
                      Save
                    </button>
                  )}
                </div>
              </div>
            </div>
        </Modal>
      </>
    );
  }
}
